import {
    CLAN_SUPPLY_PROGRESSION_REQUEST,
    CLAN_SUPPLY_PROGRESSION_SUCCESS,
    CLAN_SUPPLY_PROGRESSION_ERROR,
} from '../actions/clan_supply_progression'

export const initialState = {
    errorMessage: null,
    loading: false,
    loaded: false,
    lastRequestTimestamp: null,
}

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case CLAN_SUPPLY_PROGRESSION_REQUEST: {
        return {
            ...state,
            loading: true,
            errorMessage: null,
            lastRequestTimestamp: Date.now(),
        }
    }
    case CLAN_SUPPLY_PROGRESSION_SUCCESS: {
        return {
            ...state,
            ...action.payload,
            loading: false,
            loaded: true,
            lastRequestTimestamp: Date.now(),
        }
    }
    case CLAN_SUPPLY_PROGRESSION_ERROR: {
        return {
            ...state,
            loading: false,
            loaded: false,
            errorMessage: action.payload.errorMessage || action.payload.statusCode,
            lastRequestTimestamp: Date.now(),
        }
    }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/clan_supply_progression.js